/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Summary_StaleInputs */

const cs_ebr_summary_stale = /** @type {(inputs: Ebr_Summary_StaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Změněno od náhledu (přeskočeno)`)
};

const en_ebr_summary_stale = /** @type {(inputs: Ebr_Summary_StaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changed since preview (skipped)`)
};

/**
* | output |
* | --- |
* | "Changed since preview (skipped)" |
*
* @param {Ebr_Summary_StaleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_summary_stale = /** @type {((inputs?: Ebr_Summary_StaleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Summary_StaleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_summary_stale(inputs)
	return cs_ebr_summary_stale(inputs)
});